export default {
    conditionImport: 'เงื่อนไขการนำเข้าไฟล์',
    firstImportCondition: 'ไฟล์ต้องอยู่ในรูปแบบของ Excel โดยระบุข้อมูลพนักงานอย่างชัดเจน : รหัสพนักงาน, ชื่อ-นามสกุลพนักงาน, อีเมล, สายงาน, สำนักงาน และ ตำแหน่งงาน',
    secondImportCondition: 'หลังจากที่เพิ่มไฟล์รายชื่อพนักงาน ให้อัปโหลดข้อมูลรูปภาพใบหน้าพนักงานทั้งหมดที่อยู่ในไฟล์ Excel',
    thirdImportCondition: 'กรุณาตรวจสอบความถูกต้องก่อนอัปโหลดไฟล์',
    uploadFile: 'อัพโหลดไฟล์ของคุณ',
    shouldBeExcel: 'ไฟล์ Excel',
    dragDrop: 'ลากเเละวางไฟล์ ของคุณตรงนี้ หรือ',
    browse: 'กดที่นี่',
    uploadOneFile: 'กรุณาอัพโหลดทีละไฟล์',
    wrongFileFormat: 'ประเภทไฟล์ไม่ถูกต้อง',
    uploadedFile: 'ไฟล์ที่อัพโหลดเเล้ว',
    importResult: 'ผลการนำเข้ารายชื่อพนักงาน'
}
